import React, {  Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import {
	updatePages,
	updateSelectedItems,
	addExtraProduct,
	updateOtherAddedProducts
} from '../../redux/actions';

import AccountNumberAutoSuggests from '../PostLogin/common/accountNumberAutoSuggests';

class SelectProductsToAssignOverlayDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: true,
			selectedProducts: [],
			showErrorMessage: false,
			MAX_ALLOWED_BLANK_TEXT_FIELD: 5,
			checked : true,
			filteredItems : this.props.state.brochure.selectedItems,
        }
		this.updatePagesFromSelectedProductsFromState = this.updatePagesFromSelectedProductsFromState.bind(this);
    }
    closeDialog(event) {
        event.preventDefault();
		var self = this,
			otherAddedProducts = [];
		let { state } = self.props;
		if (state.brochure.selectedBrochureCreateOption !== 1) {
			state.brochure.otherAddedProducts.map((item, index) => {
				if(item.inValid === false) {
					item.sequence = otherAddedProducts.length + 1;
					otherAddedProducts.push(item);
				}
				return null;
			});
			//Update store with updated other updateOtherAddedProducts
			self.props.updateOtherAddedProducts(otherAddedProducts);
		}

        self.setState({
            showDialog: false,
			selectedProducts: _.find(state.brochure.payload.brochure.pages, ["pageNumber", self.props.selectedPageNumber]).products
        });
    }
	componentDidMount() {
		// window.scrollTo(0, 0);
		const self = this;
		let { state } = this.props,
			{ brochure } = state,
			{ selectedItems, selectedBrochureCreateOption } = brochure;
		var currentPageProducts = _.find(brochure.payload.brochure.pages, ["pageNumber", this.props.selectedPageNumber]),
			products = [];

		const filteredSelectedItems = this.filterSelectedItems(this.state.checked);
		self.setState({ filteredItems: filteredSelectedItems });
		currentPageProducts = currentPageProducts?currentPageProducts.products:[];

		currentPageProducts.forEach((item, index) => {
			products.push({
				productNumber: item.productNumber,
                productName: item.productName,
                sequence: item.sequence,
                price: ''
			})
		})
		if (selectedBrochureCreateOption === 1) {
			const showNumberOfBlankTextField = self.state.MAX_ALLOWED_BLANK_TEXT_FIELD - selectedItems.length;
			self.props.updateOtherAddedProducts([]);
			_.times(showNumberOfBlankTextField, () => {
				self.props.addExtraProduct();
			});
		}
		self.setState({
			selectedProducts: products,
		});
	}
	handleSelectProduct(productNumber, productName, event) {
		var selectedProducts = this.state.selectedProducts;
		let dialogErrorMessage = '';
		//Check if checkbox is checked and currently added item length is less than 5
		if(event.target.checked && selectedProducts.length < 5) {
			selectedProducts.push({
				productNumber: productNumber,
                productName: productName,
                sequence: selectedProducts.length + 1,
                price: ''
			});
		}
		//Check if checkbox is checked and currently added item length is already 5
		else if(event.target.checked && selectedProducts.length === 5) {
			event.preventDefault();
			dialogErrorMessage = "Sorry, you may only select up to 5 products.";
		} else {
			selectedProducts = _.pullAllBy(selectedProducts, [{ 'productNumber': productNumber }], 'productNumber');
		}
		this.setState({
			dialogErrorMessage,
			selectedProducts: selectedProducts,
			showErrorMessage: false,
		});
	}
	handleSelectAddedProduct(productNumber, detail, event) {
		var selectedProducts = this.state.selectedProducts;
		let dialogErrorMessage = '';
		//Check if checkbox is checked and currently added item length is less than 5
		if(event.target.checked && selectedProducts.length < 5) {
			selectedProducts.push({
				productNumber: productNumber,
                productName: '',
                sequence: selectedProducts.length + 1,
                price: ''
			});
		}
		//Check if checkbox is checked and currently added item length is already 5
		else if(event.target.checked && selectedProducts.length === 5) {
			event.preventDefault();
			dialogErrorMessage = "Sorry, you may only select up to 5 products.";
		} else {
			selectedProducts = _.pullAllBy(selectedProducts, [{ 'productNumber': productNumber }], 'productNumber');
		}
		this.setState({
			dialogErrorMessage,
			selectedProducts: selectedProducts
		});
	}
	updatePagesFromSelectedProductsFromState() {
		let { state } = this.props;
		var self = this,
			pages = state.brochure.payload.brochure.pages;

		//Update products of current page
		pages.map((item, index) => {
			if(item.pageNumber === self.props.selectedPageNumber) {
				item.products = self.state.selectedProducts;
			}
			return null;
		})
		//now update it to store with updated pages data
		self.props.updatePages(pages);
	}
	handleAddProductsToPage(event) {
		event.preventDefault();
		const self = this,
			{ state } = self.props;
		//Update products of current page
		self.updatePagesFromSelectedProductsFromState();
		//Remove blank added extra product first
		const productNumber = [];
		state.brochure.otherAddedProducts.forEach((item, index) => {
			//Check whether user has added product but yet to validate
			if(item.productNumber !== "" && !item.details) {
				productNumber.push(item.productNumber);
			}
		});
		//added only products which are not blank
		let otherAddedProducts = [];
		if (state.brochure.selectedBrochureCreateOption !== 1) {
			state.brochure.otherAddedProducts.forEach((item, index) => {
				if(item.productNumber !== "") {
					item.sequence = otherAddedProducts.length + 1;
					otherAddedProducts.push(item);
				}
			});
			//Update store with updated other updateOtherAddedProducts
			self.props.updateOtherAddedProducts(otherAddedProducts);
		} else {
			otherAddedProducts = state.brochure.otherAddedProducts;
		}

		//If other products added is greater than 0 means needs to validate product numbers
		if(self.state.selectedProducts.length > 0) {
			//Hide dialog
			self.setState({
				showDialog: false
			});
		} else if (productNumber.length > 0) {
			var selectedItems = state.brochure.selectedItems;
			var selectedProducts = self.state.selectedProducts;
			var isInvalidProductNumber = false;
			otherAddedProducts.forEach((item, index) => {
				//Move all valid added other products to selected items list
				if(item.details) {
					selectedItems.push({
						itemType: item.details.itemType,
						item: item.details.sku,
						quantity: 1,
						itemDescription: item.details.description
					});
					//Set description of any existing listed product if it is not there
					if(_.find(selectedProducts, ["productNumber", item.details.sku])) {
						selectedProducts.forEach((itm, ind) => {
							if(itm.productNumber === item.details.sku) {
								itm.productName = item.details.description;
							}
						})
					}
					if(isInvalidProductNumber === false) {
						isInvalidProductNumber = _.find(selectedProducts, ["productNumber", item.details.sku])?false:true;
					}
				}
			});
			//Update products of current page
			self.setState({
				selectedProducts: selectedProducts,
				showErrorMessage: false,
			}, () => {
				self.updatePagesFromSelectedProductsFromState();

				//update selected items
				self.props.updateSelectedItems(selectedItems);
				//Update store with updated other updateOtherAddedProducts
				//Exclude all products which are valid and already moved to selected items from this array
				self.props.updateOtherAddedProducts(_.filter(otherAddedProducts, ["inValid", true]));

				if(!isInvalidProductNumber) {
					//Hide dialog
					self.setState({
			            showDialog: false
			        });
				}
			});
		} else if (productNumber.length === 0) {
			//Update products of current page
			self.setState({
				showErrorMessage: true
			});
		}
	}
	handleAddProduct(event) {
		event.preventDefault();
		this.props.addExtraProduct();
		var myVar = setInterval(function(){
			var div = document.getElementById("assignProductContainer");
			div.scrollTop = div.scrollHeight - div.clientHeight + 43;
			clearInterval(myVar);
		}, 200);
	}
	handleAddProductChange(itemIndex, productDetails) {
		const self = this;
		const { brochure } = self.props.state;
		let { otherAddedProducts, selectedBrochureCreateOption }= brochure;

		otherAddedProducts.map((item, index) => {
			if((item.sequence-1) === itemIndex) {
				item.productNumber =  productDetails.sku;
                if(productDetails.status){
                    item.inValid = false;
					item.details = productDetails;
                } else {
					item.inValid = true;
					item.details = null;
				}
			}
			return null;
		});

        if(productDetails.status){
            var selectedItems = self.state.filteredItems;
            var selectedProducts = self.state.selectedProducts;
            otherAddedProducts.map((item, index) => {
                //Move all valid added other products to selected items list
                if(item.details) {
                    selectedItems.push({
                        itemType: item.details.itemType,
                        item: item.details.sku,
                        quantity: 1,
                        itemDescription: item.details.description
                    });
					//Set description of any existing listed product if it is not there
                    if(_.find(selectedProducts, ["productNumber", item.details.sku])) {
                        selectedProducts.map((itm, ind) => {
                            if(itm.productNumber === item.details.sku) {
                                itm.productName = item.details.description;
                            }
                            return null;
                        })
                    }
                }
                return null;
            });

            //Update products of current page
            self.setState({
                selectedProducts: selectedProducts
            }, () => {
                self.updatePagesFromSelectedProductsFromState();
            })
			selectedItems = [...selectedItems, ...brochure.selectedItems]
            //update selected items
            self.props.updateSelectedItems(selectedItems);
			if (selectedBrochureCreateOption === 1) {
				otherAddedProducts = otherAddedProducts.filter(item => (item.sequence - 1) !== itemIndex);
				otherAddedProducts.forEach((item, index) => {
					item.sequence = (index + 1);
				});
	        	self.props.updateOtherAddedProducts(otherAddedProducts);
			} else {
				//Update store with updated other updateOtherAddedProducts
				//Exclude all products which are valid and already moved to selected items from this array
				self.props.updateOtherAddedProducts(_.filter(otherAddedProducts, ["inValid", true]));
			}
        } else {
			self.props.updateOtherAddedProducts(otherAddedProducts);
		}
	}
    handleAddProductBlur(indx, value) {
        var self = this,
            otherAddedProducts = [];
        let { state } = self.props;

		state.brochure.otherAddedProducts.map((item, index) => {
			if(indx === item.sequence-1) {
	            item.sequence = otherAddedProducts.length + 1;
	            item.inValid = false;
	            item.productNumber = '';
			}
            otherAddedProducts.push(item);
            return null;
        });
        //Update store with updated other added products
        self.props.updateOtherAddedProducts(otherAddedProducts);
    }
	handleChangeProductNumberTextBox(indx, productNumber, productListSuggestion, isValid) {
		var self = this,
            otherAddedProducts = [];
        let { state } = self.props;
        state.brochure.otherAddedProducts.map((item, index) => {
			if(indx === item.sequence-1 && !productListSuggestion) {
				item.inValid = isValid;
				item.productNumber = productNumber;
			}
            otherAddedProducts.push(item);
            return null;
        });
        //Update store with updated other added products
        self.props.updateOtherAddedProducts(otherAddedProducts);
	}
	handleHideProductsAssigned() {
		const newChecked = !this.state.checked;
		const filteredSelectedItems = this.filterSelectedItems(newChecked);
		this.setState({
		  checked: newChecked,
		  filteredItems: filteredSelectedItems,
		});
	  }

	filterSelectedItems(checked) {
		const { brochure } = this.props.state;
		const uniqueProducts = Object.values(
		  brochure.payload.brochure.pages.flatMap(page => page.products)
			.reduce((acc, product) => {
			  acc[product.productNumber] = product;
			  return acc;
			}, {})
		);
		const uniqueProductNumbers = new Set(uniqueProducts.map(p => String(p.productNumber)));
		return checked
		  ? this.state.filteredItems.filter(item => !uniqueProductNumbers.has(String(item.item)))
		  : brochure.selectedItems;
	  }
    render() {
		const self = this;
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="selectProductsToAssignOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
					<h2 className="title">Assign Products to Page {this.props.selectedPageNumber}</h2>
					{this.state.dialogErrorMessage !== "" && <p className={"importantText bold red"}>{this.state.dialogErrorMessage}</p>}
					{this.state.showErrorMessage && <p className={"bold red"}>You must select products in order to add them to a page.</p>}
					<p style={{display:"flex"}}>
						<label className="bold noUnderline addProductLink" style={{color:"#144480"}}>Hide Products already assigned to the brochure</label>
						<input style={{marginLeft:"29%"}} type="checkbox" id="hideAssignedProducts" checked={self.state.checked} onChange={this.handleHideProductsAssigned.bind(this)}/>
					</p>
					{this.state.dialogErrorMessage === "" && this.state.selectedProducts.length >= 1 && this.state.selectedProducts.length <= 5 && <p className={"importantText bold"}>Maximum 5 products per page.</p>}
					<form className="selectProductsToAssignForm" name="selectProductsToAssignForm" id="selectProductsToAssignForm">
						<div id="assignProductContainer" style={{paddingBottom: 43, height: 300, overflow: 'auto'}}>
							<table className="dataTableType2 selectProductsToAssignTable" style={{marginTop: 0}}>
								<thead>
									<tr>
										<th className="product">Product</th>
										<th className="select">Select<br /><span className="unbold">(up to 5)</span></th>
									</tr>
								</thead>
								<tbody>
									{this.state.filteredItems.map((item, index) => {
										return <tr key={index}>
											<td className="product">
												<div className="productSKU">{item.item}</div>
												<div className="productDescription">{item.itemDescription}</div>
											</td>
											<td className="select">
												{/*new brochure single change*/}
												<input type="checkbox" className="selectProductCheckbox" checked={_.find(self.state.selectedProducts, ["productNumber", item.item])} onChange={this.handleSelectProduct.bind(this, item.item, item.itemDescription)} name="selectProduct" defaultValue={item.item} />
											</td>
										</tr>
									})}
									{this.props.state.brochure.otherAddedProducts.map((item, index) => {
										var data = _.find(self.state.selectedProducts, ["productNumber", item.productNumber]);
										return <tr key={self.state.filteredItems.length + index}  id={"brochureTableRow"+index}  className={item.inValid === true?"error":""}>
											<td className="product">
												<AccountNumberAutoSuggests value={item.productNumber} placeHolder="Enter model number" updateQuickOrderState={this.handleAddProductChange.bind(this)} onChangeProductNumberTextBox={this.handleChangeProductNumberTextBox.bind(this)} updateProductChangeBlur={this.handleAddProductBlur.bind(this)}  size={8} itemIndex={index} />
												{(item.inValid === true)
													?<span className="red">Invalid product Number.</span>
													:null
												}
											</td>
											<td className="select">
												<input type="checkbox" className="selectProductCheckbox" checked={data?true:false} onChange={self.handleSelectAddedProduct.bind(this, item.productNumber, item.detail)} defaultValue={item.productNumber} disabled={item.productNumber.trim() === "" || item.inValid === true || !data?true:false} />
											</td>
										</tr>
									})}
								</tbody>
							</table>
                        </div>
						<p>
							<a className="bold noUnderline uppercase addProductLink" href="" onClick={this.handleAddProduct.bind(this)}>+ <u>Add Product</u></a>
						</p>
						<button className="noButton" onClick={this.closeDialog.bind(this)}>Cancel</button>
						<p className="yesButtonContainer">
							<input className="blueButton" onClick={this.handleAddProductsToPage.bind(this)} value="Add to Page" type="submit" />
						</p>
					</form>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	updateOtherAddedProducts: (payload) => dispatch(updateOtherAddedProducts(payload)),
	updatePages: (payload) => dispatch(updatePages(payload)),
	updateSelectedItems: (payload) => dispatch(updateSelectedItems(payload)),
	addExtraProduct: () => dispatch(addExtraProduct())
});

SelectProductsToAssignOverlayDialog = connect(mapStateToProps, mapDispatchToProps)(SelectProductsToAssignOverlayDialog);
export default SelectProductsToAssignOverlayDialog;


// WEBPACK FOOTER //
// ./src/App/components/dialogs/selectProductsToAssignOverlayDialog.js